import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import VLFCard from "@/components/Card";
import MainActions from "@/components/MainActions";
import VLFSelectNew from "@/components/Input/SelectNew";

import {CompetitionAPI} from "@/api/competition";

import ArrowBack from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";

import {checkRequiredFields, getTextField} from "@/utils/functions";
import {
	SUCCESSFUL_OPERATION,
	ERROR_OPERATION,
	REQUIRED_FIELD,
} from "@/utils/constants";

import "./index.scss";

const COMPETITION_TYPE_OPTIONS = [
	{value: "Campionato", label: "Campionato"},
	{value: "Coppa", label: "Coppa"},
	{value: "Torneo", label: "Torneo"},
	{value: "Amichevole", label: "Amichevole"},
];

const HandleCompetitionPage = (props) => {
	const {edit, handleNotification} = props;

	const navigate = useNavigate();
	const {id} = useParams();

	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState([]);
	const [fields, setFields] = useState({});

	const getCompetition = async () => {
		setLoading(true);
		try {
			const response = await CompetitionAPI.getById(id);
			response.currentType = COMPETITION_TYPE_OPTIONS.find(
				(o) => o.value === response.competitionType,
			);
			setFields(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	const saveCompetition = async () => {
		const requiredFields = ["name", "currentType"];
		const errors = checkRequiredFields(requiredFields, fields);
		setErrors(errors);

		if (!errors.length) {
			const body = {
				...fields,
				competitionType: fields.currentType?.value,
			};
			setLoading(true);
			try {
				edit
					? await CompetitionAPI.update(id, body)
					: await CompetitionAPI.create(body);
				navigate("/settings/competitions");
				handleNotification(SUCCESSFUL_OPERATION, "success");
			} catch (error) {
				handleNotification(ERROR_OPERATION, "error");
				setLoading(false);
			}
		}
	};

	useEffect(() => {
		if (edit) {
			getCompetition();
		}
	}, [edit]);

	const handleSubmit = (event) => {
		event.preventDefault();
		saveCompetition();
	};

	const goBack = () => {
		navigate("/settings/competitions");
	};

	const mainActions = [
		{icon: <ArrowBack />, title: "Indietro", onClick: goBack, color: "info"},
		{icon: <SaveIcon />, title: "Salva", onClick: handleSubmit},
	];

	const breadcrumbsElements = [
		{label: "Competizioni", path: "/settings/competitions"},
	];
	if (edit) {
		breadcrumbsElements.push(
			{label: "/"},
			{
				label: fields.name || "",
				path: "/settings/competitions/" + id + "/edit",
			},
		);
	}

	const defaultTextField = {
		values: fields,
		setValues: setFields,
		errors,
		setErrors,
	};

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				elements={breadcrumbsElements}
				current={edit ? "Modifica" : "Nuova competizione"}
				actions={<MainActions actions={mainActions} />}
			/>
			<div className="sheet-container">
				<div className="row no-margin">
					<div className="col-sm-12 padding-small">
						<VLFCard
							openable={false}
							title="Informazioni principali"
							content={
								<div className="row">
									<div className="col-12 col-md-6">
										{getTextField({
											...defaultTextField,
											fieldKey: "name",
											label: "Nome",
											required: true,
										})}
									</div>
									<div className="col-12 col-md-6">
										<VLFSelectNew
											options={COMPETITION_TYPE_OPTIONS}
											sorted={false}
											value={fields.currentType}
											onChange={(newValue) => {
												setErrors([]);
												setFields({...fields, currentType: newValue});
											}}
											label="Tipologia"
											required
											helperText={
												errors.indexOf("currentType") !== -1
													? REQUIRED_FIELD
													: ""
											}
											error={errors.indexOf("currentType") !== -1}
										/>
									</div>
								</div>
							}
						/>
					</div>
				</div>
			</div>
		</Page>
	);
};

export default HandleCompetitionPage;
